import React from 'react'
import _ from 'underscore'
import styled from 'styled-components'
import { Moment, tz } from 'moment-timezone'

import CollapsiblePanel from 'components/CollapsiblePanel'

import HomeownerDayNotification from 'pages/shared/HomeownerAlert/HomeownerDayNotification'
import AlertsList from 'pages/HehmDevice/Alerts/AlertsList'
import AlertIconWithCount from 'pages/shared/Alert/IconWithCount'

import { sortBasedOnSeverity } from 'helpers/alerts'
import { shortMonthDay } from 'helpers/formatters'

import { Alert } from 'types/Alert'

import { color } from 'styles/colors'

type Props = {
  occurredDay: number
  timeZone: string
  alerts: Array<Alert>
  showDayRthCallback: (day: Moment) => void
}

const AlertsDayHistory = ({ occurredDay, timeZone, alerts, showDayRthCallback }: Props) => {
  sortBasedOnSeverity(alerts)

  const countAlertTypes = _.chain(sortBasedOnSeverity(alerts)).groupBy(alert => alert.severity).value()

  return (
    <S.CollapsiblePanel key={occurredDay}
      headerComponent={
        <S.Header>
          <span>
            {shortMonthDay(tz(occurredDay, timeZone))}
          </span>
          <S.AlertTypes>
            {_.map(Object.entries(countAlertTypes), ([key, value]) => <AlertIconWithCount key={key} severity={key} count={value.length} />)}
          </S.AlertTypes>
        </S.Header>
      }
    >
      <AlertsList alerts={alerts.slice(0, 20)} headerType="AlertHistory" showDayRthCallback={showDayRthCallback} />
      {alerts.length > 20 && <S.Note>Over 20 alerts were triggered on this day, see Runtime History for more details.</S.Note>}
    </S.CollapsiblePanel>
  )
}

export default AlertsDayHistory

const S = {
  CollapsiblePanel: styled(CollapsiblePanel)`
    > div:nth-child(1) {
       margin-left: -15px;
    }
  `,
  Header: styled.div`
    display: flex;
    padding: 10px 0px;
    align-items: center;
  `,
  AlertTypes: styled.div`
    display: flex;
    align-items: normal;
    margin-left: 10px;
  `,
  Note: styled.div`
    text-align: center;
    font-style: italic;
    margin: 10px;
    color: ${color('ancillaryText')};
  `,
  HomeownerLastNotified: styled(HomeownerDayNotification)`
    margin: 0 15px 0 auto;
  `
}
